import React from 'react';
import { format } from 'date-fns';
import './EventPopup.css';

const EventPopup = ({ date, events, userEventIds = new Set(), onClose }) => {
    if (!events || events.length === 0) return null;

    const isPrivateNotInvited = (event) => 
        event.eventType === 'private' && !userEventIds.has(event._id);

    const getHeaderTitle = () => {
        if (events.length > 1) return 'Multiple Events';
        const event = events[0];
        if (isPrivateNotInvited(event)) {
            return `Private Event${event.category ? ` - ${event.category}` : ''}`;
        }
        return event.title;
    };

    return (
        <div className="event-popup-overlay" onClick={onClose}>
            <div className="event-popup" onClick={(e) => e.stopPropagation()}>
                <div className="event-popup-header">
                    <h3 className="event-popup-header-title">
                        {getHeaderTitle()}
                    </h3>
                </div>
                <div className="event-popup-content">
                    {events.map((event, index) => {
                        if (isPrivateNotInvited(event)) {
                            return (
                                <div key={event._id || index} className="event-popup-item">
                                    <p className="private-event-message">
                                        <strong>Private Event{event.category ? ` - ${event.category}` : ''}</strong>
                                    </p>
                                </div>
                            );
                        }
                        return (
                            <div key={event._id || index} className="event-popup-item">
                                <div className="event-popup-item-header">
                                    <h4>{events.length > 1 ? event.title : format(date, 'EEEE, MMMM d, yyyy')}</h4>
                                    <span className="event-time">{event.time}</span>
                                </div>
                                <div className="event-popup-item-details">
                                    {events.length > 1 && (
                                        <p><strong>Date:</strong> {format(date, 'EEEE, MMMM d, yyyy')}</p>
                                    )}
                                    {event.hijriDate && (
                                        <p><strong>Hijri Date:</strong> {event.hijriDate}</p>
                                    )}
                                    {event.venue && <p><strong>Venue:</strong> {event.venue}</p>}
                                    {event.program && (
                                        <p><strong>Program:</strong> {event.program}</p>
                                    )}
                                    {event.womenOnly && (
                                        <p><strong>Women Only Event</strong></p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default EventPopup;
